// *** We are not allowed to use hardcoded URLs in this scenario use .env file
// the following values are available on .env file
export const BASE_URL = process.env.REACT_APP_API_URL;
export const PRODUCT_BASE_URL = process.env.REACT_APP_PRODUCT_API_URL;
export const PUBLIC_BASE_URL = process.env.REACT_APP_PUBLIC_BASE_URL;
export const CLOUD_FRONT_URL = process.env.REACT_APP_CANDIDATE_CLOUD_FRONT_URL;
export const UPLOADED_ANSWER_URL = process.env.REACT_APP_UPLOADED_ANSWER_URL;
export const HR_BASE_URL = process.env.REACT_APP_HR_BASE_URL;
export const EMP_BASE_URL = process.env.REACT_APP_EMP_BASE_URL;
export const VIEW_DOC_BASE_URL = process.env.REACT_APP_VIEW_DOC_URL;
export const VIEW_MEDIA_URL = process.env.REACT_APP_VIEW_UPLOADED_MEDIA_URL;
export const EMPLOYEE_BASE_URL = process.env.REACT_APP_EMP_BASE_URL;
export const SUPPLEMENT_BASE_URL = process.env.REACT_APP_SUPPLEMENT_BASE_URL;
export const IMAGE_CDN = process.env.REACT_APP_IMAGE_CDN;
export const FRONTEND_BASE_URL = process.env.REACT_APP_FRONTEND_BASE_URL;